var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4H5C3.34315 4 2 5.34315 2 7V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V7C22 5.34315 20.6569 4 19 4ZM5 18C4.44772 18 4 17.5523 4 17V14.58L7.3 11.29C7.68884 10.9089 8.31116 10.9089 8.7 11.29L15.41 18H5ZM20 17C20 17.5523 19.5523 18 19 18H18.23L14.42 14.17L15.3 13.29C15.6888 12.9089 16.3112 12.9089 16.7 13.29L20 16.58V17ZM20 13.76L18.12 11.89C16.9357 10.7522 15.0643 10.7522 13.88 11.89L13 12.77L10.12 9.89C8.93567 8.75217 7.06432 8.75217 5.88 9.89L4 11.76V7C4 6.44772 4.44772 6 5 6H19C19.5523 6 20 6.44772 20 7V13.76Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default ForwardRef;